// extracted by mini-css-extract-plugin
module.exports = {"editable":"ChampEmails_editable__5czL1"};